import { push } from "connected-react-router";
import actionTypes from "../../constants/action-types";
import { questionnaireReviewService } from "../services/QuestionnaireReview.service";
import loaderActions from "./loader";
import PATHS from "../../routes/routes-path";

const questionnaireReviewSuccess = (questionRespnse) => ({ type: actionTypes.questionnaireReview.SUBMIT_REVIEW_SUCCESS, questionRespnse });

const questionnaireReviewFailure = (error) => ({ type: actionTypes.questionnaireReview.SUBMIT_REVIEW_FAILURE, error });

const getQuestionnaireResponse = (qstResponse, reviewId, productId, next) =>(dispatch)=> {
  dispatch(loaderActions.show());
  questionnaireReviewService.addQuestionnaireReview(qstResponse, reviewId,productId)
    .then(
      (response) => {
        dispatch(questionnaireReviewSuccess(response.data));
        dispatch(push(`${PATHS.reviewProduct}${productId}?section=3`));
        dispatch(loaderActions.hide());
      },
      (error) => {
        dispatch(questionnaireReviewFailure(error & error.message));
        dispatch(loaderActions.hide());
      }
    )
};

const QuestionniareResponseActions = {
  getQuestionnaireResponse,
  questionnaireReviewSuccess,
  questionnaireReviewFailure
}

export default QuestionniareResponseActions;
